import * as React from 'react';
import {ConfigObjectType, StateId} from 'src/js/common';
import {LanguageSwitcherContainer} from 'src/js/containers/i18n';
import LoginMenuContainer from 'src/js/containers/login/components/LoginMenuContainer';

import styles from './Header.less';

interface OwnProps {
  config: ConfigObjectType;
  loginStateId: StateId;
  titleText?: string;
}

type Props = OwnProps;

export const Header: React.FC<Props> = (props) => {
  const {config, loginStateId, titleText = ''} = props;
  return (
    <div className={styles.dlHeader}>
      <span className={styles.dlHeaderTitleText}>{titleText}</span>
      <div className={styles.dlHeaderRightWrapper}>
        <div className={styles.dlHeaderLanguage}>
          <LanguageSwitcherContainer />
        </div>
        <div className={styles.dlHeaderLoginButton}>
          <LoginMenuContainer stateId={loginStateId} config={config} />
        </div>
      </div>
    </div>
  );
};

Header.displayName = 'Header';
